import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {FatturazionePRComponent} from './fatturazione-pr';
import {PrComponiFatturaAvanazataModule} from './pr-componi-fattura-avanzata/pr-componi-fattura-avanzata.module';
import {PRComponiFatturaConfirmModule} from './pr-componi-fattura-confirm/pr-componi-fattura-confirm.module';
import {
  WorkerComponiFatturaPRConfirmModalModule
} from './worker-componi-fattura-pr-confirm-modal/worker-componi-fattura-pr-confirm-modal.module';
import {ComponiFatturaPRSummaryModule} from './componi-fattura-pr-summary/componi-fattura-pr-summary.module';
import {ComponiFatturaPRSempliceModule} from './componi-fattura-pr-semplice/componi-fattura-pr-semplice.module';
import {PRCaricaFatturaModule} from './pr-carica-fattura/pr-carica-fattura.module';
import {CaricaFatturaPRSummaryModule} from './carica-fattura-pr-summary/carica-fattura-pr-summary.module';
import {VisualizzaStatoFatturePRModule} from './visualizza-stato-fatture-pr/visualizza-stato-fatture-pr.module';
import {
  PRFatturaElettronicaPassivaModule
} from './pr-fattura-elettronica-passiva/pr-fattura-elettronica-passiva.module';
import {
  RequestCodiceDestinatarioFatturaPRModule
} from './request-codice-destinatario-fattura-pr/request-codice-destinatario-fattura-pr.module';
import {VisualizzaPRFilterModule} from './visualizza-pr-filter/visualizza-pr-filter.module';
import {WorkerCaricaFatturaPRModalModule} from './worker-carica-fattura-pr-modal/worker-carica-fattura-pr-modal.module';
import {RiferimentoPRModalModule} from './riferimento-pr-modal/riferimento-pr-modal.module';
import {DettaglioLineePRModalModule} from './dettaglio-linee-pr-modal/dettaglio-linee-pr-modal.module';
import {RubricaSearchPRModalModule} from './rubrica-search-pr-modal/rubrica-search-pr-modal.module';
import {RubricaInsertPRModalModule} from './rubrica-insert-pr-modal/rubrica-insert-pr-modal.module';
import {DatiOrdinePRModalModule} from './dati-ordine-pr-modal/dati-ordine-pr-modal.module';
import {DatiDDTPRModalModule} from './dati-ddt-pr-modal/dati-ddt-pr-modal.module';
import {RitenutaAccontoPRModalModule} from './ritenuta-acconto-pr-modal/ritenuta-acconto-pr-modal.module';
import {BolloVirtualePRModalModule} from './bollo-virtuale-pr-modal/bollo-virtuale-pr-modal.module';
import {
  WorkerFatturazioneGeneratePackagePRModalModule
} from './worker-fatturazione-generate-package-pr-modal/worker-fatturazione-generate-package-pr-modal.module';
import {
  FatturaElettronicaPassivaFilterModule
} from './fattura-elettronica-passiva-filter/fattura-elettronica-passiva-filter.module';
import {EnableFatturaPRModalModule} from './enable-fattura-pr-modal/enable-fattura-pr-modal.module';
import {
  AcceptFatturaElettronicaPassivaModalModule
} from './accept-fattura-elettronica-passiva-modal/accept-fattura-elettronica-passiva-modal.module';
import {FatturazioneComponentModule} from '../component/fatturazione-component.module';
import {
  WorkerFatturazioneDownloadFatturePRModalModule
} from './worker-download-fatture-pr-modal/worker-download-fatture-pr-modal.module';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {
  $stateProvider
    .state('home.fatturazione-pr', {
      url: '/fatturazione-pr',
      ncyBreadcrumb: {
        label: 'Fatturazione PR',
        parent: 'home.fatturazione'
      },
      data: {
        authorisationLevel: 1,
        pageTitle: 'Fatturazione PR'
      },
      'views': {
        'homeContent': {
          template: '<fatturazione-pr flex="100"></fatturazione-pr>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const FatturazionePRModule: string = ng
  .module('fatturazione-pr', [
    'ui.bootstrap',
    uiRouter,
    PrComponiFatturaAvanazataModule,
    PRComponiFatturaConfirmModule,
    WorkerComponiFatturaPRConfirmModalModule,
    ComponiFatturaPRSummaryModule,
    ComponiFatturaPRSempliceModule,
    PRCaricaFatturaModule,
    CaricaFatturaPRSummaryModule,
    VisualizzaStatoFatturePRModule,
    PRFatturaElettronicaPassivaModule,
    RequestCodiceDestinatarioFatturaPRModule,
    VisualizzaPRFilterModule,
    WorkerCaricaFatturaPRModalModule,
    RiferimentoPRModalModule,
    DettaglioLineePRModalModule,
    RubricaSearchPRModalModule,
    RubricaInsertPRModalModule,
    DatiOrdinePRModalModule,
    DatiDDTPRModalModule,
    RitenutaAccontoPRModalModule,
    BolloVirtualePRModalModule,
    WorkerFatturazioneGeneratePackagePRModalModule,
    WorkerFatturazioneDownloadFatturePRModalModule,
    FatturaElettronicaPassivaFilterModule,
    EnableFatturaPRModalModule,
    AcceptFatturaElettronicaPassivaModalModule,
    FatturazioneComponentModule
  ])
  .component('fatturazionePr', FatturazionePRComponent)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/fatturazione-pr.module.ts